import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="ChatGPTTripAdvisor"
              description="This project is a cool demo where users can sign up and
              log in, and then when they type a region, city, or country,
              it gives them historical and tourist information about that
              place.Also In this project, the database has been designed
              using the Code First approach, and database changes with
              Migrations. The application's performance has been
              enhanced and communication between objects has been
              facilitated by utilizing the CQRS and Mediator patterns.
              "
              ghLink="https://github.com/fatihzt/ChatGptTripAdvisor"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="Redis Application"
              description="This project is a demo project designed to understand the
              purpose of the Redis.Also In this project, the database has
              been designed using the Code First approach, and database
              changes with Migrations. The application's performance
              has been enhanced and communication between objects
              has been facilitated by utilizing the CQRS and Mediator
              patterns."
              ghLink="https://github.com/fatihzt/RedisApplication"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="Moviestagram"
              description="This project is a fun demo where users can sign up and
              log in. They can explore movie and TV show information
              in different genres and add them to custom lists according
              to their preferences. Finally, if they want, they can share
              their lists with everyone.Also In this project, the database
              has been designed using the Code First approach, and
              database changes with Migrations. The application's
              performance has been enhanced and communication
              between objects has been facilitated by utilizing the CQRS
              and Mediator patterns."
              ghLink="https://github.com/fatihzt/Moviestagram"
              demoLink="https://moviestagram.vercel.app"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="Cd Center"
              description="This project is a cool demo where users can sign up and
              log in. After that, they can view the movie information
              added by the admin and add them to their carts for
              purchase. The project uses the DB First method.
              "
              ghLink="https://github.com/fatihzt/CdCenter"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="Selenium"
              description="The project first navigate to the specified page, then
              enters the login credentials into the required field,
              performs the login, navigates through different pages by
              clicking on certain buttons, and finally ends by logging
              out."
              ghLink="https://github.com/fatihzt/Selenium"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
